

export const SET_CLEAR_DATA = 'boilerplate/SAVEGSTR9C/SET_CLEAR_DATA';
export const SET_GSTR9C_DATA ='boilerplate/SAVEGSTR9C/SET_GSTR9C_DATA';
export const PROFILE_INFO = 'boilerplate/SAVEGSTR9C/PROFILE_INFO';
export const SET_TOTAL_RECORD = 'boilderplate/PREPAREGSTR9C/SET_TOTAL_RECORD';
export const LOADER_STATUS = 'boilderplate/SAVEGSTR9C/LOADER_STATUS';
export const SET_AUTO_POPULATED_HISTORY = 'boilderplate/SAVEGSTR9C/SET_AUTO_POPULATED_HISTORY';
export const SET_SUBMIT_DOWNLOAD ='boilderplate/SAVEGSTR9C/SET_SUBMIT_DOWNLOAD'

export const SET_RELOAD_DATA ='boilderplate/SAVEGSTR9C/SET_RELOAD_DATA'